module.exports = __webpack_public_path__ + "static/media/ic_business_24px.23607552.svg";